<template>
  <div>
    <el-table
      v-loading="pageDefultConf.loadingState"
      :data="dataList"
      style="width: 100%; margin-top: 25px"
      border
      :cell-class-name="tableCellClass"
      :header-row-class-name="tableHeaderClass"
    >
      <el-table-column
        header-align="center"
        align="center"
        type="index"
        width="84px"
        label="序号"
      >
      </el-table-column>
      <el-table-column
        header-align="center"
        align="center"
        prop="policyCode"
        label="保单号"
      >
      </el-table-column>
      <el-table-column
        header-align="center"
        align="center"
        prop="goodsName"
        label="产品名称"
      >
      </el-table-column>
      <el-table-column
        header-align="center"
        align="center"
        prop="applicantName"
        label="投保人"
      >
      </el-table-column>
      <el-table-column
        header-align="center"
        align="center"
        prop="insuredName"
        label="被保险人"
      >
      </el-table-column>
      <el-table-column
        header-align="center"
        align="center"
        prop="coverage"
        label="保额 (元)"
      >
      </el-table-column>
      <el-table-column
        width="110px"
        header-align="center"
        align="center"
        prop="insureTime"
        label="投保时间"
      >
      </el-table-column>
      <el-table-column
        header-align="center"
        align="center"
        prop="policyStatus"
        label="保单状态"
      >
      </el-table-column>
      <el-table-column
        width="65px"
        header-align="center"
        align="center"
        label="操作"
      >
        <template #default="scope">
          <div>
            <div @click="goDetail(scope.row.orderCode)" class="detail-btn">
              <span>详情</span>
            </div>
          </div>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination
      class="page-style"
      @size-change="handleSizeChange"
      @current-change="getList"
      :current-page.sync="pageDefultConf.currentPage"
      :page-sizes="pageDefultConf.pageSizes"
      :page-size.sync="pageDefultConf.pageSize"
      :layout="pageDefultConf.layout"
      :total="pageDefultConf.total"
    />
  </div>
</template>

<script>
import { queryAllChaosOrderList } from "@/api/insideJobManage";
export default {
  name: "queryList",
  data() {
    return {
      pageDefultConf: {
        // 分页默认配置
        currentPage: 1,
        pageSize: 10,
        pageSizes: [10, 20, 30, 100],
        total: 1,
        layout: "total, sizes, prev, pager, next, jumper",
        loadingState: false,
      },
      dataList: [],
    };
  },
  created() {
    this.getList();
  },
  methods: {
    goDetail(code) {
      console.log(code);
      this.$emit("select-detail", code);
      this.$emit("state-change", "2");
    },
    tableHeaderClass() {
      return "table-header";
    },
    tableCellClass() {
      return "table-cell";
    },
    async getList() {
      this.pageDefultConf.loadingState = true;
      const promise = await queryAllChaosOrderList({
        channelNo:"8093322e7b2c11eba6d67cd30aeb1984",
        queryKey: sessionStorage.getItem("token"),
        currentPage: this.pageDefultConf.currentPage,
        pageSize: this.pageDefultConf.pageSize,
      });
      // console.log(res)
      const res = promise.data;
      if (res.code === 10000) {
        this.dataList = res.data.dataList || [];
        this.pageDefultConf.total = res.data.total;
      }

      this.pageDefultConf.loadingState = false;
    },
    handleSizeChange() {
      this.pageDefultConf.currentPage = 1;
      this.getList();
    },
  },
};
</script>

<style lang="less" scoped>
.page-style {
  margin-top: 40px;
  text-align: center;
  ::v-deep .el-pager li.active {
    cursor: default;
    color: #2488CA;
  }
}
.detail-btn {
  cursor: pointer;
  width: 44px;
  height: 24px;
  background: #2488CA;
  border-radius: 2px;
  display: flex;
  align-items: center;
  justify-content: center;
  span {
    font-size: 12px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #ffffff;
  }
}
::v-deep .el-table .table-header {
  font-size: 16px;
  font-family: PingFangSC-Medium, PingFang SC;
  font-weight: 500;
  color: #333333;
  line-height: 22px;
  th {
    background: #ebebeb;
    border: 1px solid #f5f5f5;
  }
}

::v-deep .el-table .table-cell {
  font-size: 14px;
  font-family: PingFangSC-Medium, PingFang SC;
  font-weight: 400;
  color: #333333;
  line-height: 18px;
}
</style>
